import { make } from 'vuex-pathify';
import { keyBy } from 'lodash';
import {
    prepScreens,
    prepChoices,
    prepTypes,
    prepPrescription,
    prepCommitment,
    prepMotivators,
    prepAdherence,
    prepAdherenceSupport,
    prepAdherenceGaps,
    prepIrregularDownsides,
    prepBarriers,
    prepRegularSupport,
    prepRegularStrategies,
    prepMotivatorsRevisited,
    prepAdherenceRevisited,
    prepRegularStrategiesRevisited,
    prepReminder
} from '@/components/pages/9/section9prep';

import {
    artScreens,
    artChoices,
    artTypes,
    artCommitment,
    artMotivators,
    artAdherence,
    artAdherenceSupport,
    artAdherenceGaps,
    artIrregularDownsides,
    artBarriers,
    artRegularSupport,
    artRegularStrategies,
    artMotivatorsRevisited,
    artAdherenceRevisited,
    artRegularStrategiesRevisited,
    artReminder
} from '@/components/pages/9/section9art';

const statements = keyBy(
    [
        {
            id: 1,
            text: 'Having HIV is not the same as having AIDS.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 2,
            text: 'Coughing and sneezing do not spread HIV.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 3,
            text: 'A person can get HIV from having oral sex.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 4,
            text: 'Anal sex is more risky than vaginal sex.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 5,
            text: 'If you’ve had sex without a condom already, there’s no point in continuing to use condoms.',
            correctAnswer: 'false',
            answer: ''
        },
        {
            id: 6,
            text: 'Using Vaseline or baby oil with latex condoms lowers the chance of getting or passing HIV.',
            correctAnswer: 'false',
            answer: ''
        },
        {
            id: 7,
            text: 'Latex condoms protect against all sexually transmitted infections.',
            correctAnswer: 'false',
            answer: ''
        },
        {
            id: 8,
            text: 'Pre-exposure prophylaxis (or PrEP) is when people take HIV medicines to lower their chances of getting HIV.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 9,
            text: 'If you take PrEP, you can’t take hormones at the same time.',
            correctAnswer: 'false',
            answer: ''
        },
        {
            id: 10,
            text: 'There are medications that people who are not living with HIV can take after sex to prevent HIV infection.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 11,
            text: 'You can live a long, full, healthy life with HIV.',
            correctAnswer: 'true',
            answer: ''
        },
        {
            id: 12,
            text:
                'People living with HIV who take their HIV medicine as prescribed with an undetectable viral load (the amount of HIV in the blood) have no risk of passing HIV to others through sex.',
            correctAnswer: 'true',
            answer: ''
        }
    ],
    'id'
);

const state = {
    title: 'HIV True False',
    complete: false,
    sticker: {
        text: 'Red Heart',
        earned: false,
        image: require('@/assets/stickers/stickers_0000_heart.png')
    },
    bonusSticker: false,
    trophy: false,
    statements,
    prepScreens,
    prepChoices,
    prepTypes,
    prepPrescription,
    prepCommitment,
    prepMotivators,
    prepAdherence,
    prepAdherenceSupport,
    prepAdherenceGaps,
    prepIrregularDownsides,
    prepBarriers,
    prepRegularSupport,
    prepRegularStrategies,
    prepMotivatorsRevisited,
    prepAdherenceRevisited,
    prepRegularStrategiesRevisited,
    prepReadiness: null,
    prepReminder,
    artScreens,
    artChoices,
    artTypes,
    artCommitment,
    artMotivators,
    artAdherence,
    artAdherenceSupport,
    artAdherenceGaps,
    artIrregularDownsides,
    artBarriers,
    artRegularSupport,
    artRegularStrategies,
    artMotivatorsRevisited,
    artAdherenceRevisited,
    artRegularStrategiesRevisited,
    artReadiness: null,
    artReminder,
    prepVisited: false,
    artVisited: false,
    finalScreen: 73,
    firstPrepScreen: Object.keys(prepScreens)[0],
    firstArtScreen: Object.keys(artScreens)[0]
};
const getters = make.getters(state);
const mutations = make.mutations(state);
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
